import React from 'react'
import './Header.css'

const Header = () => (
  <div className="row">
    <div className="col Header">
      <h1 className="mb-3">Run for Office</h1>
      <p className="lead">
        Learn more about open positions you can run for in your community.
      </p>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/HomeScene/Header/Header.js